import React from 'react';
type SectionHeadingProps = {
  children: React.ReactNode;
  variant?: 'filled' | 'plain';
  as?: 'h2' | 'h3';
};
export function SectionHeading({
  children,
  variant = 'filled',
  as: Tag = 'h2'
}: SectionHeadingProps) {
  return <Tag className={`px-4 py-2 text-base font-semibold uppercase tracking-[0.25em] text-ink sm:text-lg ${variant === 'filled' ? 'bg-blush-300' : 'bg-white'}`} data-id="element-23" data-mp="3f2n5xuqe6mpf">
      {children}
    </Tag>;
}